import { gql } from 'graphql-tag';

export const GET_PROMO_CODE_FROM_SESSION = gql`
  query {
    getPromoCodeFromSession {
      promoCode
      discountDetails {
        actor
        promoID
        name
        amount
        type
        validLocations
        validSkus
        formattedBanner
      }
    }
  }
`;
